var map = {
	"./facebook.png": 7276,
	"./instagram.png": 1646,
	"./line.png": 9545,
	"./linkedin.png": 6822,
	"./pinterest.png": 5165,
	"./skype.png": 9011,
	"./telegram.png": 7280,
	"./twitter.png": 4803,
	"./wechat.png": 8224,
	"./whatsapp.png": 6869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6512;